import React from "react";
import { LeafIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
export function FinalCta() {
  return <section className="w-full bg-paper px-5 py-16 md:py-24" data-id="element-175" data-mp="1nnyc6u3c7pla">
      <div className="mx-auto max-w-3xl text-center" data-id="element-176" data-mp="1so2t2l85qmc1">
        <h2 className="font-serif text-[34px] font-extrabold leading-tight text-ink [text-wrap:balance] md:text-5xl" data-id="element-177" data-mp="1smhy4uhxl1dn">
          Are you ready to create something that <span className="italic text-brand-lavender" data-id="element-178" data-mp="1iqelgupgdkcg">feels like yours?</span>
        </h2>
        <div className="mx-auto mt-6 max-w-xl space-y-3 text-[17px] leading-relaxed text-ink/80 md:text-lg" data-id="element-179" data-mp="14qdk7e5a0awg">
          <p data-id="element-180" data-mp="19oowrwmygzid">You don't need to know everything today. You don't need a huge product catalog. You don't need a complicated business.</p>
          <p className="font-semibold text-ink" data-id="element-181" data-mp="2z4oalr1ird4c">You just need an idea… and a system to help you develop it.</p>
        </div>
        <img src={images.mainMockup} alt="The Aroma Lab complete system" className="-mx-5 mt-6 w-[calc(100%+2.5rem)] max-w-none md:mx-auto md:w-full md:max-w-xl" data-id="element-182" data-mp="34158hcyit5um" />
        <p className="mt-4 font-serif text-5xl font-extrabold text-brand-cta" data-id="element-183" data-mp="3tdbm6tea156k">Only $27</p>
        <div className="mt-6" data-id="element-184" data-mp="b0nekgq04vl9">
          <CtaButton label="I Want to Enter The Aroma Lab™" sub="One-Time Payment · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-185" data-mp="703fh7lvbhwh" />
        </div>
        <div className="mt-8" data-id="element-186" data-mp="3fhhnf377vw76">
          <Countdown data-id="element-187" data-mp="3ahbtthhdzzmg" />
        </div>
        <p className="mt-8 flex items-center justify-center gap-2 font-serif text-xl italic text-brand-olive" data-id="element-188" data-mp="3ai4vi41hnyxq">
          I'll see you inside The Aroma Lab.
          <LeafIcon className="h-5 w-5" aria-hidden="true" data-id="element-189" data-mp="3jgqiqchwo24u" />
        </p>
      </div>
    </section>;
}